// MHM-3.5 — Standalone full-page version of the order detail surface.
// Mounted at /dashboard/hub/orders/:tracking_id so the drawer can be
// deep-linked / opened in a new tab / linked from emails.
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import RoleGate from "../../components/RoleGate";
import MHMSubNav from "../../components/hub/MHMSubNav";
import { OrderDetailBody } from "../../components/hub/OrderDetailDrawer";

export default function OrderDetailPage() {
  const { trackingId } = useParams();
  const nav = useNavigate();
  return (
    <RoleGate allow={["main_hub_manager", "admin", "founder", "ceo"]}>
      <MHMSubNav />
      <div className="max-w-[1100px] mx-auto px-3 sm:px-6 py-4" data-testid="order-detail-page">
        <button onClick={() => nav("/dashboard/hub/orders")}
                data-testid="order-detail-page-back"
                className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900 mb-3">
          <ArrowLeft className="h-4 w-4" /> Back to orders
        </button>
        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden"
             style={{ minHeight: "70vh" }}>
          <OrderDetailBody tid={trackingId} embedded={false} />
        </div>
      </div>
    </RoleGate>
  );
}
